/**
 * Тексты приветствий для дашборда фотографа.
 * Используйте {name} там, где должно быть имя пользователя.
 * Если {name} нет — текст будет без имени.
 */
const GREETINGS = [
    "Здарова заебал 🤪",
    "Саламалейкум, {name} 🤝",
    "Привет, {name} 🤟",
    "Добрый день, {name} 👋",
    "Работаем, работаем, не расслабляемся 👀",
    "Давно не виделись, {name} 🫂",
    "Хей, {name}! Что нового? ✌️",
    "Упал? Вставай! Встал? Упай",
    "О, явился, не запылился! 🤡",
    "Живой? Ну и слава богу 💀",
    "Йо, {name}, как жизнь молодая? 🤙",
    "Приветик-пистолетик, {name}! 🔫",
    "Просыпаемся, кожаные мешки! 🤖",
    "Хватит тупить, пора созидать! 🔨",
    "Включаем режим турбо, {name} 🚀",
    "Меньше слов — больше дела! 😤",
    "Внимание, обнаружен объект «{name}»! 🚨",
    "Слышь, ты зачем пришел? 🤔",
    "На связи, {name}! 📡",
    "Включаем режим терминатора! 🤖",
    "Меньше чесания пуза, больше дела! 🛠️",
    "Погнали штурмовать вершины! 🏔️",
    "Рабочая атмосфера сама себя не создаст 👀",
    "Не спи, а то проспишь жизнь! 👁️",
    "Твой успех сам себя не сделает 🏆",
    "Двигайся, а то заржавеешь! ⚙️",
    "Делай красиво, {name}! ✨"
];

export default GREETINGS;